import { languages } from './languages'

export const languageCodeByName = (langName: string): string | undefined => {
  return Object.keys(languages).find((key) => languages[key].name === langName)
}
